import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Breadcrumb, Tab, Button, Icon } from 'semantic-ui-react'

import { ProcurementContainer, ProcurementBody } from '../../styled'
import { MainBodyContent, CustomButton, K2ErrorModal } from 'components'
import { purchaseOrderPath } from 'routes'
import DocumentStep from '../../Shared/DocumentStep'
import RequestInformation from '../Shareds/RequestInformation'

import { getPoDetail, getPoApprover, getPOErrorWorkFlow } from 'ducks/purchaseOrder'
import { getHrmsMembers, getPurchaseUsers, getAllMembers } from 'ducks/member'
import Approve from '../Shareds/Approve'
import Summary from '../Shareds/Summary'
import General from '../Shareds/General'
import Detail from '../Shareds/Detail'
import Attachment from '../Shareds/Attachment'
import Comment from '../Shareds/Comment'

const PurchaseOrderDetail = (props) => {
  const { history, valueForm, approvers, k2workFlowError, change, handleSubmit, isDetail = true } = props

  React.useEffect(()=>{
    let poId = props.match.params.poId
    props.getPoDetail(poId, history, true)
    props.getAllMembers(isDetail)
    // props.getHrmsMembers(isDetail)
  },[])

  React.useEffect(()=>{
    if(valueForm.id){
      props.getPoApprover(valueForm.id)
    }
  },[valueForm&&valueForm.id])

  React.useEffect(()=>{
    if(Object.keys(valueForm).length>0){
      if(valueForm.companyCode&& valueForm.purchGroup){
        props.getPurchaseUsers(valueForm.companyCode, valueForm.purchGroup)
      }
    }
  },[valueForm.companyCode])

  React.useEffect(() => {
    if (valueForm&&valueForm.status&&valueForm.status!==0) {
      props.getPOErrorWorkFlow(valueForm.procInstId, valueForm.subProcInstId)
    }
  },[valueForm&&valueForm.status])
  
  return (
    <MainBodyContent
  headerTitle={<React.Fragment>{valueForm.isSpecialCreditTerm&&<Icon size='tiny' name='star' color='yellow'/>}{`Purchase Orders - ${valueForm.documentNumber ? valueForm.documentNumber : 'Detail'}`}</React.Fragment>}
      accessoriesHeader={
        <div style={{ display: 'flex' }}>
          {
            valueForm.urlPrintFormPo ?
            <Button 
              basic  
              circular 
              type='button' 
              content='View PO form' 
              labelPosition='right'
              icon='clipboard list' 
              onClick={()=>(window.open(valueForm.urlPrintFormPo,"_blank"))}/> : null
          }
          <CustomButton 
            onClick={() => history.push(purchaseOrderPath)}
            icon='close'
            btnColor='red'
            title='Close'/>
          </div>
        }
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={[
            { key: 'PO', content: 'Purchase Orders', link: true, onClick: () => history.push(purchaseOrderPath) },
            { key: 'PO_Detail', content: valueForm.documentNumber ? valueForm.documentNumber : 'Detail', active: true }
          ]}
        />
      }
      accessoriesHeaderLeft={
        k2workFlowError.isError&&
          <K2ErrorModal checkK2Error={k2workFlowError}/>  
      }
    >
      <ProcurementContainer>
        <ProcurementBody>
          <DocumentStep documentDetail={{ ...valueForm }} approvers={approvers} />
          <RequestInformation isDetail isNewVersion={valueForm.isNewVersion}/>
          <Approve history={history} isNewVersion={valueForm.isNewVersion} handleSubmit={props.handleSubmit} change={change}/>
          <Tab 
            style={{ marginTop: '10px' }}
            menu={{ attached: false }}
            panes={[
              { menuItem: 'Summary', render: () => <Summary/> },
              { menuItem: 'General', render: () => <General/> },
              { menuItem: 'Detail', render: () => <Detail/> },
              { menuItem: 'Attachment', render: () => <Attachment change={change} handleSubmit={handleSubmit} history={history} /> },
              { menuItem: 'Comment History', render: () => <Comment/> },
            ]} 
          />
        </ProcurementBody>
      </ProcurementContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => {
  var valueForm = getFormValues('formPO')(state)
  var poDetail = state.po.poDetail.data
  var poSAPData = state.po.poSAPData.data
  return ({
    initialValues: {
      ...poDetail,
      vendorName: `${poDetail.vendorCode || ''} : ${poDetail.vendorName || ''}`,
      //approverAction: ['UploadByPurchase']
    },
    poSAPData,
    poLoading: state.po.poDetail.loading,
    approvers: state.po.approvers.data,
    valueForm:valueForm||{},
    k2workFlowError: state.po.k2workFlowError,
  })
}

const mapDispatchToProps = {
  getPoDetail,
  getPoApprover,
  getHrmsMembers,
  getPurchaseUsers,
  getPOErrorWorkFlow,
  getAllMembers
}

const contForm = reduxForm({
  form: 'formPO',
  enableReinitialize: true,
})(PurchaseOrderDetail)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)
